import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useMemo } from 'react';
import { MessageType } from "../../../../../shared/api";
import { useAppDispatch, useAppSelector, useCommunicationContext } from "../../../../../shared/model";
import { ymPushClickErrorContextMenu, ymPushResendAttach } from "../../../../../shared/analytics";
import { AttachLabel, isDev } from "../../../../../shared/config";
import { copyToClipboard, getMessageText } from "../../../../../shared/lib";
import { deleteMessage, setContext, setReplyMessage } from "../../../../../entities/message/model";
import { selectChatCofig, setWindowBlocked } from "../../../../../entities/settings/model";
import { MessagePropStage } from "../../../../../entities/message/types";
import { IconCopyFilled, IconRefresh, IconReply, IconTrashFilled } from "./utils";
export var useMessageMenu = function useMessageMenu(message, stage) {
  var messageData = message.message,
    messageId = message.messageId,
    date = message.date;
  var dispatch = useAppDispatch();
  var _useAppSelector = useAppSelector(selectChatCofig),
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var _useCommunicationCont = useCommunicationContext(),
    resendMessage = _useCommunicationCont.resendMessage,
    resendImageMessage = _useCommunicationCont.resendImageMessage,
    sendFileMessage = _useCommunicationCont.sendFileMessage;
  var closeContext = function closeContext() {
    dispatch(setWindowBlocked(false));
    dispatch(setContext(undefined));
  };
  var resend = function resend() {
    var text = getMessageText(message);
    if (text) {
      resendMessage(text, messageData.replyId, messageId === null || messageId === void 0 ? void 0 : messageId.toString(), {
        value: messageData === null || messageData === void 0 ? void 0 : messageData.value,
        messageType: messageData.type
      });
    }
    if (messageData.type === MessageType.FileDoc && messageData.fileId) {
      sendFileMessage(messageData.fileId, message, true);
      ymPushResendAttach(AttachLabel.FIlE, zoneType);
    }
    if (messageData.type === MessageType.Img && messageData.fileId && messageData.filePreviewId) {
      resendImageMessage({
        imageId: messageData.fileId,
        imagePreviewId: messageData.filePreviewId
      }, message.messageId);
      ymPushResendAttach(AttachLabel.IMAGE, zoneType);
    }
    closeContext();
    ymPushClickErrorContextMenu(zoneType, 'отправить еще раз');
  };
  var remove = function remove() {
    dispatch(deleteMessage({
      id: messageId,
      date: date
    }));
    closeContext();
    ymPushClickErrorContextMenu(zoneType, 'удалить');
  };
  var replyMessage = function replyMessage() {
    dispatch(setReplyMessage(messageId));
    dispatch(setContext({
      id: messageId,
      reason: 'reply'
    }));
  };
  var copyMessage = function copyMessage() {
    var text = getMessageText(message);
    if (text) {
      void copyToClipboard(text);
    }
    closeContext();
  };
  var rejectMenu = useMemo(function () {
    var menu = [{
      label: 'отправить еще раз',
      onClick: resend,
      icon: IconRefresh
    }, {
      label: 'удалить',
      status: 'alert',
      onClick: remove,
      icon: IconTrashFilled
    }];

    // ограничиваем повторную отправку для изображений и файлов
    var limitImg = message.message.type === MessageType.Img && !message.message.fileId && !message.message.filePreviewId;
    var limitFile = message.message.type === MessageType.FileDoc && !message.message.fileId;
    if (limitImg || limitFile) {
      menu.splice(0, 1);
    }
    return menu;
  }, [resend]);
  var menu = useMemo(function () {
    return [].concat(_toConsumableArray(stage === MessagePropStage.REJECTED || !isDev ? [] : [{
      label: 'ответить',
      icon: IconReply,
      onClick: replyMessage
    }]), [{
      icon: IconCopyFilled,
      label: 'скопировать',
      onClick: copyMessage
    }]);
  }, [messageId, messageData.content, stage]);
  return {
    menu: menu,
    rejectMenu: rejectMenu
  };
};